export interface CompassConfig {
  apiBaseUrl: string;
  cognito: {
    region: string;
    userPoolId: string;
    userPoolClientId: string;
    hostedUiBaseUrl: string;
    redirectUri: string;
  };
  models: {
    default: string;
    recommended: string;
    allowed: string[];
  };
}

let cached: CompassConfig | null = null;

/**
 * Load runtime config from /config.json. CDK BucketDeployment writes this file
 * to S3 alongside the build assets, populated with the real Cognito IDs from
 * stack outputs. Local dev: copy public/config.example.json → public/config.json
 * and fill in your dev pool IDs.
 */
export async function loadConfig(): Promise<CompassConfig> {
  if (cached) return cached;
  const res = await fetch('/config.json', { cache: 'no-store' });
  if (!res.ok) {
    throw new Error(
      `Failed to load /config.json (status ${res.status}). For local dev, copy public/config.example.json → public/config.json and fill in the Cognito IDs from \`cdk deploy\` outputs.`,
    );
  }
  const cfg = (await res.json()) as CompassConfig;
  cached = cfg;
  return cfg;
}
